module.exports = __webpack_public_path__ + "static/media/matilde-cap-greece-impressed.0c66000e.png";